var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",staticStyle:{"height":"395px"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center card-top"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"background-color":"#EEEFF2"}},[_c('h5',{staticClass:"card-title",staticStyle:{"height":"48px"}},[_vm._t("title")],2),_c('hr'),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7da2f9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card.vue
// module id = 346
// module chunks = 0